import React from 'react';
import { Euro, Warehouse, Truck, Zap } from 'lucide-react';
export function Presentation() {
  const advantages = [{
    icon: <Euro size={28} data-id="element-253" />,
    title: 'Prix compétitifs',
    description: "Notre volume d'achat nous permet de négocier les meilleurs prix du marché pour vous."
  }, {
    icon: <Warehouse size={28} data-id="element-254" />,
    title: 'Large choix',
    description: 'Plus de 50 références de palettes disponibles immédiatement en stock.'
  }, {
    icon: <Truck size={28} data-id="element-255" />,
    title: 'Couverture nationale',
    description: 'Livraison garantie dans toute la France métropolitaine sous 48 à 72h.'
  }, {
    icon: <Zap size={28} data-id="element-256" />,
    title: 'Réactivité maximale',
    description: "Réponse sous 2h ouvrées pour toute demande de devis ou d'urgence."
  }];
  return <section className="py-24 bg-light relative overflow-hidden" data-id="element-257">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-gray-100 to-transparent opacity-50 -z-10" data-id="element-258"></div>

      <div className="w-full max-w-[1200px] mx-auto px-6" data-id="element-259">
        <div className="flex flex-col lg:flex-row gap-16 items-start" data-id="element-260">
          <div className="lg:w-5/12 sticky top-32" data-id="element-261">
            <div className="inline-block px-3 py-1 bg-primary-light text-primary-dark rounded-full text-sm font-semibold mb-4" data-id="element-262">
              Notre expertise
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-secondary-dark mb-6 leading-tight" data-id="element-263">
              Pourquoi choisir <br data-id="element-264" />
              <span className="text-primary" data-id="element-265">1001 Palettes ?</span>
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-266">
              Notre expertise de courtage vous offre un accès unique et
              simplifié au marché des palettes en Europe.
            </p>

            <div className="space-y-6 text-gray-600" data-id="element-267">
              <p className="flex gap-4" data-id="element-268">
                <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2.5 flex-shrink-0" data-id="element-269"></span>
                <span data-id="element-270">
                  Interlocuteur unique pour tous vos besoins, sans gérer
                  plusieurs fournisseurs.
                </span>
              </p>
              <p className="flex gap-4" data-id="element-271">
                <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2.5 flex-shrink-0" data-id="element-272"></span>
                <span data-id="element-273">
                  Réseau de +500 partenaires qualifiés à travers l'Europe.
                </span>
              </p>
              <p className="flex gap-4" data-id="element-274">
                <span className="w-1.5 h-1.5 rounded-full bg-primary mt-2.5 flex-shrink-0" data-id="element-275"></span>
                <span data-id="element-276">
                  Flexibilité totale sans contrat long terme contraignant.
                </span>
              </p>
            </div>

            <div className="mt-10" data-id="element-277">
              <a href="#gamme" className="text-primary font-semibold hover:text-primary-dark transition-colors inline-flex items-center group" data-id="element-278">
                Découvrir nos solutions
                <span className="ml-2 w-8 h-[2px] bg-primary group-hover:w-12 transition-all" data-id="element-279"></span>
              </a>
            </div>
          </div>

          <div className="lg:w-7/12 grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-280">
            {advantages.map((adv, index) => <div key={index} className={`
                  bg-white p-8 rounded-2xl border border-gray-100 shadow-sm hover:shadow-xl hover:-translate-y-2 transition-all duration-300 group relative overflow-hidden
                  ${index % 2 === 1 ? 'lg:mt-12' : ''}
                `} data-id="element-281">
                <div className="absolute top-0 right-0 w-32 h-32 bg-primary/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-primary/10 transition-colors" data-id="element-282"></div>
                <div className="relative z-10" data-id="element-283">
                  <div className="w-14 h-14 bg-primary-light rounded-xl flex items-center justify-center text-primary mb-6 group-hover:bg-primary group-hover:text-white transition-colors duration-300 shadow-sm group-hover:shadow-lg group-hover:shadow-primary/20" data-id="element-284">
                    {adv.icon}
                  </div>
                  <h4 className="text-xl font-bold text-secondary-dark mb-3" data-id="element-285">
                    {adv.title}
                  </h4>
                  <p className="text-gray-500 leading-relaxed text-sm" data-id="element-286">
                    {adv.description}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}